import template from './unitaudit.html';
import controller from './unitaudit.controller';
import './unitaudit.styl';

let unitauditComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default unitauditComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/unitaudit/unitaudit.component.js